import {Criterion} from "./criterion";
import {CohortInfo} from "./cohortinfo";

export class Cohort {
  name: string;
  info: CohortInfo;
  criteria: Criterion[];

  constructor() {
    this.info = new CohortInfo();
    this.criteria = [
      new Criterion("any"),
      new Criterion("none")
    ];
  }
}
